"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFriendlyError = exports.getFriendlyMessage = exports.defaultConfig = void 0;
exports.defaultConfig = {
    rejected_request: 'Could not perform desired action',
    server_exception: (status) => `An unhandled server exception occurred. If this continues, please report this error to MakeMyMove. (Error ${status})`,
    client_exception: 'An unhandled client exception occurred. If this continues, please report this error to MakeMyMove.',
    not_authenticated: 'You are not logged in',
    no_permission: 'You don\'t have permission to do that',
    not_found: 'The target requested does not exist or has been deleted',
    rate_limited: 'You are making too many requests',
    no_connection: 'Could not reach the server, please try again later',
};
const getFriendlyMessage = (error, config) => {
    var _a;
    const status = Number((error === null || error === void 0 ? void 0 : error.status) || ((_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.status)) || null;
    const statusMapping = {
        null: config.client_exception,
        400: config.rejected_request,
        401: config.not_authenticated,
        403: config.no_permission,
        404: config.not_found,
        409: config.rejected_request,
        429: config.rate_limited,
        500: config.server_exception,
        502: config.no_connection,
        503: config.no_connection,
    };
    let message = '';
    if (Object.keys(statusMapping).includes(String(status))) {
        message = statusMapping[String(status)];
    }
    else {
        message = config.server_exception;
    }
    return typeof message === 'function' ? message(status, error) : message;
};
exports.getFriendlyMessage = getFriendlyMessage;
const getFriendlyError = (error, config) => {
    const finalConfig = Object.assign(Object.assign(Object.assign({}, exports.defaultConfig), (config.all
        ? Object.fromEntries(Object.entries(exports.defaultConfig).map(([key]) => [key, config.all]))
        : {})), config);
    const message = (0, exports.getFriendlyMessage)(error, finalConfig);
    return Object.assign(Object.assign({}, error), { friendly: typeof message === 'string' && message !== '' ? message : (0, exports.getFriendlyMessage)(error, exports.defaultConfig) });
};
exports.getFriendlyError = getFriendlyError;
